import { StoryNodeDisplayType } from "../../storyV2/domain/StoryNodeDisplayType";
import isBlank from "@sedan-utils/is-blank";
export class WebsocketFileParams {
    constructor(file_url, method, body, headers) {
        this.file_url = file_url;
        this.method = method;
        this.body = body;
        this.headers = headers;
    }
}
export class WebsocketMetadata {
    constructor(response, error) {
        this.response = response;
        this.error = error;
    }
}
export class WebsocketResponse {
    constructor(status, metadata, type, response, text, html, audio, audio_url, image, image_url, video, video_url, pdf, pdf_url, ask_brain, /// json | undefined
    method, body, headers, error, event, message) {
        this.status = status;
        this.metadata = metadata;
        this.type = type;
        this.response = response;
        this.text = text;
        this.html = html;
        this.audio = audio;
        this.audio_url = audio_url;
        this.image = image;
        this.image_url = image_url;
        this.video = video;
        this.video_url = video_url;
        this.pdf = pdf;
        this.pdf_url = pdf_url;
        this.ask_brain = ask_brain;
        this.method = method;
        this.body = body;
        this.headers = headers;
        this.error = error;
        this.event = event;
        this.message = message;
    }
    get succeed() {
        if (this.status && this.status === "failed") {
            return false;
        }
        /// 如果不存在 stauts
        return true;
    }
    get displayType() {
        /// 如果 type 为空，展示 text, 值为 metadata.response
        if (isBlank(this.type)) {
            return StoryNodeDisplayType.TEXT;
        }
        const displayType = WebsocketResponse.wsTypesMap.get(this.type);
        if (displayType === StoryNodeDisplayType.UPLOADIMAGE && (!isBlank(this.image_url) || !isBlank(this.image))) {
            return StoryNodeDisplayType.UPLOADIMAGE;
        }
        if (displayType === StoryNodeDisplayType.AUDIO && (!isBlank(this.audio_url) || !isBlank(this.audio))) {
            return StoryNodeDisplayType.AUDIO;
        }
        if (displayType === StoryNodeDisplayType.VIDEO && (!isBlank(this.video_url) || !isBlank(this.video))) {
            return StoryNodeDisplayType.VIDEO;
        }
        if (displayType === StoryNodeDisplayType.PDFFILE && (!isBlank(this.pdf_url) || !isBlank(this.pdf))) {
            return StoryNodeDisplayType.PDFFILE;
        }
        if (displayType === StoryNodeDisplayType.HTML && !isBlank(this.html)) {
            return StoryNodeDisplayType.HTML;
        }
        if (displayType === StoryNodeDisplayType.ASKBRAIN && !isBlank(this.ask_brain)) {
            return StoryNodeDisplayType.ASKBRAIN;
        }
        return StoryNodeDisplayType.TEXT;
    }
    get content() {
        /// 如果 type 为空，展示 text, 值为 metadata.response
        if (isBlank(this.type)) {
            return this.metadata?.response;
        }
        /// 类型为 html
        /// 如果存在 html 数据（返回 undefined）
        if (this.displayType === StoryNodeDisplayType.HTML && !isBlank(this.html)) {
            return undefined;
        }
        /// 类型为 ask_brain
        /// 如果存在 ask_brain 数据（返回 undefined）
        if (this.displayType === StoryNodeDisplayType.ASKBRAIN && !isBlank(this.ask_brain)) {
            return undefined;
        }
        /// 类型为图片/音频/视频/PDF文件，
        /// 如果存在链接/使用链接（返回 undefined）
        if (this.isFileUrlTypes && !isBlank(this.fileParams?.file_url)) {
            return undefined;
        }
        /// 兼容处理，如果 type === image_url 但是 image_url 值为空
        return this.text || this.metadata?.response;
    }
    /// 通过 url 加载数据的类型
    get isFileUrlTypes() {
        return (this.displayType === StoryNodeDisplayType.UPLOADIMAGE ||
            this.displayType === StoryNodeDisplayType.AUDIO ||
            this.displayType === StoryNodeDisplayType.VIDEO ||
            this.displayType === StoryNodeDisplayType.PDFFILE);
    }
    get fileParams() {
        if (this.displayType === StoryNodeDisplayType.UPLOADIMAGE) {
            return new WebsocketFileParams(this.image_url || this.image, this.method, this.body, this.headers);
        }
        if (this.displayType === StoryNodeDisplayType.VIDEO) {
            return new WebsocketFileParams(this.video_url || this.video, this.method, this.body, this.headers);
        }
        if (this.displayType === StoryNodeDisplayType.AUDIO) {
            return new WebsocketFileParams(this.audio_url || this.audio, this.method, this.body, this.headers);
        }
        if (this.displayType === StoryNodeDisplayType.PDFFILE) {
            return new WebsocketFileParams(this.pdf_url || this.pdf, this.method, this.body, this.headers);
        }
        return undefined;
    }
    get errorMsg() {
        return this.metadata?.error;
    }
    get isPlaceholderMessage() {
        if (!this.event || isBlank(this.event)) {
            return false;
        }
        return this.event.startsWith("on_llm") || this.event.startsWith("on_tool_start");
    }
}
WebsocketResponse.wsTypesMap = new Map([
    ["image", StoryNodeDisplayType.UPLOADIMAGE],
    ["image_url", StoryNodeDisplayType.UPLOADIMAGE],
    ["audio", StoryNodeDisplayType.AUDIO],
    ["audio_url", StoryNodeDisplayType.AUDIO],
    ["video", StoryNodeDisplayType.BASEVIDEO],
    ["video_url", StoryNodeDisplayType.BASEVIDEO],
    ["html", StoryNodeDisplayType.HTML],
    ["pdf", StoryNodeDisplayType.PDFFILE],
    ["pdf_url", StoryNodeDisplayType.PDFFILE],
    ["ask_brain", StoryNodeDisplayType.ASKBRAIN],
    ["text", StoryNodeDisplayType.TEXT],
]);
